import request from "@/utils/require";

export function getToolsList() {
  return request({
    url: "/file/manager/indexApkList",
    method: 'GET'
  })
}